import React, { useState } from 'react';
import { Fade, Stack, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';
import Transition from '../../components/Transition/Transition';
import PageHeader from '../../components/PageHeader/PageHeader';
import Video from '../../components/Video/Video';
import Photos from '../../components/Photos/Photos';

const galleryImages = [ /* image list remains unchanged */ ];

function Gallery() {
  const { t } = useTranslation();
  const [showAlbum, setShowAlbum] = useState(true); // Default to Album

  return (
    <Stack direction="row" sx={{ justifyContent: "center", minHeight: "65.5vh", backgroundColor: "background.main" }}>
      <Fade in={true} timeout={2000}>
        <Stack direction="column" marginTop="30px" height="100%" width={{ md: "85%", xs: "100%" }} spacing={2}>
          <PageHeader weight={t("NavBar.Gallery.length")}>
          <Stack direction="row" sx={{  justifyContent: 'center', alignItems: 'center', gap: 2 }} >
            <Box
              onClick={() => setShowAlbum(true)}
              sx={{
                cursor: 'pointer',
                color: showAlbum ? 'red.light' : 'text.primary',
                textDecoration: showAlbum ? 'underline' : 'none',
                fontWeight: 500,
                textUnderlineOffset: "0.8vh"
              }}
            >
              {t("NavBar.Gallery.photo")}
            </Box>

            <Box sx={{ height: '20px', borderLeft: '1px solid gray' }} />

            <Box
              onClick={() => setShowAlbum(false)}
              sx={{
                cursor: 'pointer',
                color: !showAlbum ? 'red.light' : 'text.primary',
                textDecoration: !showAlbum ? 'underline' : 'none',
                fontWeight: 500,
                textUnderlineOffset: "0.8vh"
              }}
            >
              {t("NavBar.Gallery.video")}
            </Box>
</Stack>
          </PageHeader>

          {/* Toggle Words */}
          

          {/* Content */}
          {showAlbum ? <Photos /> : <Video />}
        </Stack>
      </Fade>
    </Stack>
  );
}

export default Transition(Gallery);